import { API } from './resources'

export default {
  get: (name) => {
    return API.get('/features', { params: { featureGroupName: name, pageSize: 10 } })
  }
}
